import { useState } from 'react'

import { shipmentStatuses, useFetch } from '@reveni-io/reveni-ui'

import parcelServices from '@/parcels/services/services'

const useParcelInboundDestinationLocation = ({ storeId, parcelId, onParcelEdited, setToastInfo, parcel }) => {
  const { fetchData, loading } = useFetch(parcelServices.editParcel, { doInitialRequest: false })
  const [showEditInboundDestinationLocationModal, setShowEditInboundDestinationLocationModal] = useState(false)

  const openEditInboundDestinationLocationModal = () => {
    setShowEditInboundDestinationLocationModal(true)
  }

  const closeEditInboundDestinationLocationModal = () => {
    setShowEditInboundDestinationLocationModal(false)
  }

  const onEditInboundDestinationLocation = async location => {
    const payload = { recipient_location: location }

    try {
      const updatedShipment = await fetchData({ storeId, parcelId, payload })
      closeEditInboundDestinationLocationModal()
      onParcelEdited(updatedShipment)
    } catch (error) {
      setToastInfo({ show: true, type: 'error', message: error.errorMessage })
    }
  }

  const allowEditInboundDestinationLocation = [
    shipmentStatuses.requested,
    shipmentStatuses.packed,
    shipmentStatuses.ready,
  ].includes(parcel?.status)

  return {
    showEditInboundDestinationLocationModal,
    openEditInboundDestinationLocationModal,
    closeEditInboundDestinationLocationModal,
    onEditInboundDestinationLocation,
    loading,
    allowEditInboundDestinationLocation,
  }
}

export default useParcelInboundDestinationLocation
